import {
  TestRunWidget as BotBuddyTestRunWidget,
  type TestRunWidgetProps as BotBuddyTestRunWidgetProps,
} from "@botbuddy/react";

const BOTBUDDY_WIDGET_URL = import.meta.env.VITE_BOTBUDDY_WIDGET_URL?.trim() ||
  "https://api.bot-buddy.ai/functions/v1/mcp-server";
const BOTBUDDY_DASHBOARD_URL = import.meta.env.VITE_BOTBUDDY_DASHBOARD_URL?.trim() ||
  "https://app.bot-buddy.ai";
const BOTBUDDY_PUBLISHABLE_KEY = import.meta.env.VITE_BOTBUDDY_PUBLISHABLE_KEY?.trim() ||
  [
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
    "eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRwbml2anBvYXlqbWV4Y2xmcGF2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM2NTg2NTQsImV4cCI6MjA4OTIzNDY1NH0",
    "yamBPsi_8t9ouIA-FRnp-YekQuBxC9zTrzVmdBZI714",
  ].join(".");

type TestRunWidgetProps = Omit<BotBuddyTestRunWidgetProps, "config" | "targetUrl" | "testRunId" | "testRunToken" | "ticketId"> & {
  targetUrl?: string;
  testUrl?: string;
  testRunId?: string;
  testRunToken?: string;
  ticketId?: string;
  releaseId?: string;
};

export function TestRunWidget({ releaseId, testRunId, testRunToken, ticketId, targetUrl, testUrl, ...props }: TestRunWidgetProps) {
  const resolvedTargetUrl = targetUrl ?? testUrl;

  return (
    <BotBuddyTestRunWidget
      {...props}
      config={{
        serverUrl: BOTBUDDY_WIDGET_URL,
        dashboardUrl: BOTBUDDY_DASHBOARD_URL,
        anonKey: BOTBUDDY_PUBLISHABLE_KEY,
      }}
      targetUrl={resolvedTargetUrl}
      testRunId={testRunId ?? releaseId}
      testRunToken={testRunToken}
      ticketId={ticketId}
    />
  );
}
